import { Email, Fax, Mobile, Phone, Root } from './components';

export const ContactFields = {
  Root,
  Phone,
  Mobile,
  Email,
  Fax,
};
